export const SET_VIDEO_IS_CLICKED = 'SET_VIDEO_IS_CLICKED' as const;
export const CLEAR_VIDEO_IS_CLICKED = 'CLEAR_VIDEO_IS_CLICKED' as const;

export const setVideoIsClicked = (
  videoId: string | null,
  rowTitle: string | null,
  rowPos: number | null,
  rowCol: number | null,
) => ({
  type: SET_VIDEO_IS_CLICKED,
  payload: { videoId, rowTitle, rowPos, rowCol },
});

export const clearVideoIsClicked = () => ({
  type: CLEAR_VIDEO_IS_CLICKED,
});
